import React, { useEffect, useCallback, useState } from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import { BsSearch } from 'react-icons/bs';
import * as _ from 'lodash';
import { B2C_STATION_CHARGING_HISTORY, DOWNLOAD_B2C_STATION_CHARGING_HISTORY, DOWNLOAD_METER_VALUES } from 'actions/dataReport';
import { useSelector, useDispatch } from 'react-redux';
import SearchBox from 'components/general/SearchBox';
import moment from 'moment-timezone';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import Button from 'components/inputs/Button';
import { BsDownload } from 'react-icons/bs';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { IoSearchOutline } from 'react-icons/io5';
import { BiSort } from 'react-icons/bi';
import fileDownload from 'js-file-download';
import { FETCH_COUNTRY, FETCH_STATE, GET_CITY_BY_STATE } from 'actions/address';
import { FETCH_CPO } from 'actions/partnerManagement';
import { GET_STATION_BY_CITY } from 'actions/chargingStation';
import { MdClear } from 'react-icons/md';
import { Form, Formik } from 'formik';
import Select from 'components/inputs/Select';
import OffCanvas from 'components/inputs/OffCanvas';
import ReactPagination from 'components/general/ReactPagination';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import { FaFilter } from 'react-icons/fa';
import Footer from 'components/general/Footer';
import { FETCH_TAGS } from 'actions/tagmanagement';
import { toast } from 'react-toastify';
import { getTimezoneFromCountryCode } from 'utils/timezone/timezoneUtils';


const B2CStationChargingHistory = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [searchText, setSearchText] = useState('');
  const [cityLimit, setCityLimit] = useState(false);
  // const [allB2cStationChargingHistoryData, setAllB2cStationChargingHistoryData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});
  const [changeState, setChangeState] = useState(false);
  const [changeCity, setChangeCity] = useState(false);
  const [changeStation, setChangeStation] = useState(false);
  const [country, setCountry] = useState('');
  const [isOcpiPartyId, setIsOcpiPartyId] = useState('false');
  const [state, setState] = useState('');
  const page = useSelector((state) => state.b2cStationChargingHistory.page);
  const totalData = useSelector((state) => state.b2cStationChargingHistory.total);
  const limit = useSelector((state) => state.b2cStationChargingHistory.limit);
  const totalPages = useSelector((state) => state.b2cStationChargingHistory.totalPages);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileStations = profileData.charging_stations;
  const currentUserName = _.get(profileData, 'name', '');

  const b2cStationChargingHistoryList = useSelector((state) => state.b2cStationChargingHistory.b2cStationChargingHistory);
  const isLoader = useSelector((state) => state.b2cStationChargingHistory.isLoading);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);
  const [selectedOption, setSelectedOption] = useState('station_name');
  const searchOptions = [
    { label: 'OCPP ID', value: 'ocpp_id' },
    { label: 'Station Name', value: 'station_name' },
  ];

  const countryTimezone = getTimezoneFromCountryCode(_.get(profileData, 'country_code', 'UTC'));
  const [startDate, setStartDate] = useState(moment(new Date()).tz(countryTimezone).startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).tz(countryTimezone).endOf('day'));

  const b2cStationChargingHistory = useCallback(
    (value) => {
      // Convert string to boolean for is_ocpi_based_booking if present
      const processedValue = { ...value };
      if (processedValue.is_ocpi_based_booking === 'true') {
        processedValue.is_ocpi_based_booking = true;
      } else if (processedValue.is_ocpi_based_booking === 'false') {
        processedValue.is_ocpi_based_booking = false;
      }
      
      if (searchText) {
        const b2cStationChargingHistoryData = {
          ...processedValue,
          type: 'Public',
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          status: 'completed',
          search: {
            [selectedOption]: searchText,
          },
          is_emsp_based_booking: false,
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: b2cStationChargingHistoryData,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else if (!_.isEmpty(userProfileStations)) {
        const data = {
          ...processedValue,
          type: 'Public',
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          charging_station: userProfileStations,
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      } else {
        const data = {
          ...processedValue,
          type: 'Public',
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
              onCloseAdvanceFilterPopup();
            }
          },
        });
      }
    },
    [startDate, endDate, searchText, selectedOption]
  );

  const dateFilter = useCallback(() => {
    if (sortByItem.item && sortByItem.order) {
      const filterDateData = {
        from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
        to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
        charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
        is_emsp_based_booking: false,
      };
      getSortByItem(sortByItem.item, sortByItem.order, '', filterDateData);
    } else if (!_.isEmpty(advanceFilterData)) {
      if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = {
          ...advanceFilterData,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          state: '',
          city: '',
        };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '', state: '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.state === 'All') {
        const filterData = { ...advanceFilterData, state: '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const data = {
          ...filterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else {
        const data = {
          ...advanceFilterData,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      }
    } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const filterDateData = {
        from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
        to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
        charging_station: userProfileStations,
        is_emsp_based_booking: false,
      };
      b2cStationChargingHistory(filterDateData);
    } else {
      const filterDateData = {
        from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
        to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
        is_emsp_based_booking: false,
      };
      b2cStationChargingHistory(filterDateData);
    }
  }, [startDate, endDate, sortByItem, advanceFilterData, searchText, selectedOption]);

  // useEffect(() => {
  //   setAllB2cStationChargingHistoryData(
  //     _.filter(
  //       b2cStationChargingHistoryList,
  //       (item) =>
  //         startsWith(_.get(item, 'charger.charging_station.name'), searchText) ||
  //         startsWith(_.get(item, 'transaction_id'), searchText) ||
  //         startsWith(roundOfDigit(_.get(item, 'meterstop') - _.get(item, 'meterstart'), 3).toString(), searchText) ||
  //         startsWith(millisecondsToHourMinute(_.get(item, 'time_taken')).toString(), searchText) ||
  //         startsWith(_.get(item, 'idTag').toString(), searchText) ||
  //         startsWith(_.get(item, 'stop_reason'), searchText) ||
  //         startsWith(_.get(item, 'charger.charger_id'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.name'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.vin_num'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.make'), searchText) ||
  //         startsWith(_.get(item, 'vehicle.model'), searchText)
  //     )
  //   );
  // }, [searchText, b2cStationChargingHistoryList]);

  const searchHandler = (event) => {
    const value = event.target.value;
    setSearchText(value);
  };

  const handleSearch = () => {
    b2cStationChargingHistory({});
  };

  useEffect(() => {
    if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const data = {
        charging_station: userProfileStations,
      };
      b2cStationChargingHistory(data);
    } else {
      b2cStationChargingHistory();
    }
  }, []);

  const getSortByItem = useCallback(
    (name, order, page, filterDateData) => {
      const sortedOrder = order || 'asc';
      if (page && startDate && endDate) {
        const data = {
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          is_emsp_based_booking: false,
        };
        endDate && b2cStationChargingHistory(data);
      } else if (page) {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          page: page.selected + 1,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (filterDateData) {
        const data = {
          ...filterDateData,
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          is_emsp_based_booking: false,
        };
        endDate && b2cStationChargingHistory(data);
      } else {
        const data = {
          sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      }
    },
    [startDate, endDate]
  );

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (!_.isEmpty(advanceFilterData)) {
        if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
          const filterData = {
            ...advanceFilterData,
            charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
            state: '',
            city: '',
          };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
          const filterData = { ...advanceFilterData, city: '', state: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.state === 'All') {
          const filterData = { ...advanceFilterData, state: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.city === 'All') {
          const filterData = { ...advanceFilterData, city: '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        } else if (advanceFilterData.charging_station === 'All') {
          const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
          const data = {
            ...filterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          };
          b2cStationChargingHistory(data);
        } else {
          const data = {
            ...advanceFilterData,
            page: page.selected + 1,
            from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
            to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
            is_emsp_based_booking: false,
          };
          b2cStationChargingHistory(data);
        }
      } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
        const filterDateData = {
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          charging_station: userProfileStations,
          page: page.selected + 1,
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(filterDateData);
      } else if (startDate && endDate && searchText) {
        const data = {
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          search: {
            [selectedOption]: searchText,
          },
          page: page.selected + 1,
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else if (startDate && endDate) {
        const data = {
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          page: page.selected + 1,
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      } else {
        const data = {
          page: page.selected + 1,
          is_emsp_based_booking: false,
        };
        b2cStationChargingHistory(data);
      }
    },
    [sortByItem, startDate, endDate, advanceFilterData, searchText, selectedOption]
  );

  // Download Excel Functionality

  const downloadB2CStationChargingHistory = useCallback(() => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    const startMonth = startMoment.month();
    const startYear = startMoment.year();
    const endMonth = endMoment.month();
    const endYear = endMoment.year();

    if (startMonth === endMonth && startYear === endYear) {
      const daysInMonth = startMoment.daysInMonth();
      const diffInDays = endMoment.diff(startMoment, 'days');

      if (diffInDays >= daysInMonth) {
        toast.error(`The date range exceeds ${daysInMonth} days. Please select a shorter range or download from Download Advance Report.`);
        return false;
      }
    } else {
      const startMonthDays = startMoment.daysInMonth();
      const remainingDaysInStartMonth = startMonthDays - startMoment.date() + 1;
      const daysInEndMonth = endMoment.date();

      const totalDays = remainingDaysInStartMonth + daysInEndMonth;

      if (totalDays > startMonthDays) {
        toast.error('The selected date range exceeds the allowed days. Please select a shorter range or download from Download Advance Report.');
        return false;
      }
    }
    
    // Helper function to convert is_ocpi_based_booking from string to boolean
    const processFilterData = (filterData) => {
      const processed = { ...filterData };
      if (processed.is_ocpi_based_booking === 'true') {
        processed.is_ocpi_based_booking = true;
      } else if (processed.is_ocpi_based_booking === 'false') {
        processed.is_ocpi_based_booking = false;
      }
      return processed;
    };
    
    if (!_.isEmpty(advanceFilterData)) {
      if (advanceFilterData.charging_station === 'All' && advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = {
          ...advanceFilterData,
          charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
          state: '',
          city: '',
        };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, state: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.city === 'All' && advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, city: '', charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All' && advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '', state: '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.state === 'All') {
        const filterData = { ...advanceFilterData, state: '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.city === 'All') {
        const filterData = { ...advanceFilterData, city: '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else if (advanceFilterData.charging_station === 'All') {
        const filterData = { ...advanceFilterData, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
        const processedFilterData = processFilterData(filterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      } else {
        const processedFilterData = processFilterData(advanceFilterData);
        const data = {
          ...processedFilterData,
          excel: true,
          from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
          to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
          report: 'b2cstationcharginghistory',
          type: 'Public',
          status: 'completed',
          is_emsp_based_booking: false,
        };
        dispatch({
          type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
          payload: data,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
                fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
              }
            }
          },
        });
      }
    } else if (_.isEmpty(advanceFilterData.charging_station) && !_.isEmpty(userProfileStations)) {
      const data = {
        excel: true,
        from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
        to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
        report: 'b2cstationcharginghistory',
        type: 'Public',
        status: 'completed',
        charging_station: userProfileStations,
        is_emsp_based_booking: false,
      };
      dispatch({
        type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
              fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
            }
          }
        },
      });
    } else {
      const data = {
        excel: true,
        from: moment.utc(startDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day'),
        to: moment.utc(endDate.format('YYYY-MM-DD'), 'YYYY-MM-DD').endOf('day'),
        report: 'b2cstationcharginghistory',
        type: 'Public',
        status: 'completed',
        is_emsp_based_booking: false,
      };
      dispatch({
        type: DOWNLOAD_B2C_STATION_CHARGING_HISTORY.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
              fileDownload(res.data, `${'Public Station Charging History'}.xlsx`);
            }
          }
        },
      });
    }
  }, [startDate, endDate, advanceFilterData]);

  const downloadFile = () => {
    downloadB2CStationChargingHistory();
  };

  const onMeterValuesDownloadHandler = (item) => {
    dispatch({
      type: DOWNLOAD_METER_VALUES.REQUEST,
      payload: { id: item.id },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200 || _.get(res, 'status') === 201) {
            fileDownload(res.data, `${'B2C Station Meter Values'}.xlsx`);
          }
        }
      },
    });
  };

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

  const search = (
    <div className="search-box-option">
      <Select options={searchOptions} value={selectedOption} onChange={(value) => setSelectedOption(value)} placeholder="Search Option" />
      <SearchBox
        preIcon={<BsSearch />}
        value={searchText}
        onChange={searchHandler}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            handleSearch();
          }
        }}
      />
    </div>
  );
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;
  const allCountries = useSelector((state) => state.country.countries);
  const allState = useSelector((state) => state.state.states);
  const ocpidata = useSelector((state) => state.partnerManagement.partnerDetails);
  const ocpiPage = useSelector((state) => state.partnerManagement.page);
  const alltags = useSelector((state) => state.tagmanagement.tags);
  const ocpiTotalPages = useSelector((state) => state.partnerManagement.totalPages);
  const totalStateData = useSelector((state) => state.state.total);
  const allCityByState = useSelector((state) => state.cityByState.cityByStates);
  const totalCityData = useSelector((state) => state.cityByState.total);
  const allStationByCity = useSelector((state) => state.stationByCity.stationByCities);
  const countryPage = useSelector((state) => state.country.page);
  const statePage = useSelector((state) => state.state.page);
  const cityByStatePage = useSelector((state) => state.cityByState.page);
  const countryTotalPage = useSelector((state) => state.country.totalPages);
  const stateTotalPage = useSelector((state) => state.state.totalPages);
  const cityByStateTotalPage = useSelector((state) => state.cityByState.totalPages);
  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);
  const stationList =
    userProfileStations && userProfileStations.length > 0
      ? allStationByCity.filter((x) => userProfileStations.indexOf(x.id) !== -1)
      : allStationByCity;

  const initialValues = !_.isEmpty(advanceFilterData)
    ? { ...advanceFilterData }
    : { country: '', state: '', city: '', charging_station: '', tags: '' };

  const getAllCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_COUNTRY.REQUEST, payload: data });
  }, []);

  const getStateByCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getCityByStateName = useCallback((data = {}) => {
    dispatch({ type: GET_CITY_BY_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      access_type: 'Public',
    };
    dispatch({ type: GET_STATION_BY_CITY.REQUEST, payload: stationData });
  }, []);

  const getOcpidata = useCallback(
    (data) =>
      dispatch({
        type: FETCH_CPO.REQUEST,
        payload: data,
      }),
    []
  );

  const getTags = useCallback((data = {}) => {
    dispatch({ type: FETCH_TAGS.REQUEST, payload: data });
  });


  useEffect(() => {
    if (showAdvanceFilterPopup) {
      getStateByCountry({ country_name: country, limit: totalStateData });
    }
    if (cityLimit) {
      getCityByStateName({ state_names: state, limit: totalCityData });
    }
  }, [country, state, totalStateData, totalCityData, cityLimit]);


  useEffect(() => {
    getAllCountry();
    getOcpidata({ limit: 999 });
    getTags({ limit: 999 });
  }, []);

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.b2cStationChargingHistory')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="data-report--main">
              <Card>
                <div className="data-report__inner">
                  <div className="data-report__box">
                    <Row className="data-report__row">
                      <Col
                        xl={`${showSearchBar ? 'auto' : 'auto'}`}
                        md={`${showSearchBar ? 'auto' : 'auto'}`}
                        className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                      >
                        {showSearchBar ? search : searchIcon}
                      </Col>
                      <Col xl={`${showSearchBar ? 'auto' : 'auto'}`} md={`${showSearchBar ? 'auto' : 'auto'}`}>
                        <div className="data-report-date_picker">
                          <DateTimePicker
                            onChangeOfStartDate={(item) => setStartDate(item)}
                            onChangeOfEndDate={(item) => setEndDate(item)}
                            initialValueOfStartDate={moment(new Date()).startOf('day')}
                            initialValueOfEndDate={moment(new Date()).endOf('day')}
                          />
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-box" onClick={dateFilter}>
                          <Button className="report-search-button">{t('button.search')}</Button>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="report-search-excel-block">
                          <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                            <Button className="report-search-button">
                              <FaFilter className="hide-lap" />
                              <span>{t('button.advancedFilter')}</span>
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
                        {isLoading ? (
                          <div className="loader--block">
                            <Spinner as="span" animation="border" size="sm" role="status" />
                          </div>
                        ) : (
                          <div className="report-excel-icon">
                            <BsDownload title="Download" size={28} color={'#3c7cdd'} />
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>
                  <div className="data-report__table">
                    <div className="table-responsive">
                      <table className="record-list-table" id="table-to-xls">
                        <thead>
                          <tr>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.srNo')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Country</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>State</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>City</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>OCPP Id</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.stationName')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.chargerID')}</span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.partyId')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Connector Type</span>
                              <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.transactionId')}</span>
                                <span className="ico" onClick={() => handleSorting('transaction_id', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.chargingDateTime')}</span>
                                <span className="ico" onClick={() => handleSorting('schedule_datetime', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.StartSoC')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.StopSoC')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.minTemp')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.maxTemp')}</span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Meter Start Reading(Wh)</span>
                              <span className="ico" onClick={() => handleSorting('meterstart', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>Meter Stop Reading(Wh)</span>
                              <span className="ico" onClick={() => handleSorting('meterstop', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>
                                  {isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.sessionUnitConsumption')}
                                </span>
                                <span className="ico" onClick={() => handleSorting('energy_consumed', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                                {/* <span className="ico">
                                <TiArrowUnsorted />
                              </span> */}
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Session Start Date Time(hh:mm)</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>Session Stop Date Time(hh:mm)</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.sessionDuration')}</span>
                                <span className="ico" onClick={() => handleSorting('time_taken', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>StartSoC</span>
                              <span className="ico" onClick={() => handleSorting('StartSoc', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>StopSoC</span>
                              <span className="ico" onClick={() => handleSorting('StopSoc', sortByItem)}>
                                <BiSort size={15} />
                              </span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.reasontoStop')}</span>
                                <span className="ico" onClick={() => handleSorting('stop_reason', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.stopInfo')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.idTag/OTP')}</span>
                                <span className="ico" onClick={() => handleSorting('idTag', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            {/* <th>
                            <div className="sorting">
                              <span>Mobile No.</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>VIN/Registration No.</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>EV Make</span>
                            </div>
                          </th> */}
                            {/* <th>
                            <div className="sorting">
                              <span>EV Model</span>
                            </div>
                          </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.chargerMake')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.capacity')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.connectorType')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.make')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addB2CStationChargingHistory.downloadMeterValues')}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td colSpan={9} className="border-0">
                                <div className="loader--block">
                                  <Skeleton height={15} width={100} />
                                </div>
                              </td>
                            </tr>
                          ) : _.isEmpty(b2cStationChargingHistoryList) ? (
                            <tr>
                              <td colSpan={10} className="border-0">
                                <div className="empty-data-block">{t('addB2CStationChargingHistory.noHistoryFound')}</div>
                              </td>
                            </tr>
                          ) : (
                            !(isLoader || _.isUndefined(isLoader)) &&
                            _.map(b2cStationChargingHistoryList, (item, index) => {
                              // const connectorData = _.find(_.get(item, 'charger.plugs', []), { connector_id: item.connectorId });
                              const serial_num = limit * (page - 1) + index;



                              return (
                                <tr key={`b2c-station-charging-history-${serial_num}`}>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : serial_num + 1}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'station_name', '')}</td>
                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <>
                                        {_.get(item, 'charger_id', '')} ({_.get(item, 'connector_id')})
                                      </>
                                    )}
                                  </td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'party_id', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'transaction_id', '')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'charging_date_time', '')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'start_soc', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'stop_soc', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'min_temperature', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'max_temperature', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'session_unit_consumption', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'session_duration', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'reason_to_stop', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'stop_info', '-')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'idtag_otp', '')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'charger.oem.vendor.name', '')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'capacity', '-').replace('kW', '')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'connector_id', 'N/A')}</td>
                                  <td>{isLoader ? <Skeleton height={15} width={100} /> : _.get(item, 'make_model')}</td>
                                  <td onClick={() => onMeterValuesDownloadHandler(item)}>
                                    <Button className="report-download-button">
                                      {isLoader ? <Skeleton height={15} width={100} /> : t('button.downloadExcel')}
                                    </Button>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(b2cStationChargingHistoryList) && (
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </div>
              </Card>
            </div>
          </div>
        </SkeletonTheme>
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>

      {/* Report Advance Filter Functionality */}

      {showAdvanceFilterPopup && (
        <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
          <Formik
            enableReinitialize={!_.isEmpty(advanceFilterData)}
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              !values.country && delete values['country'];
              !values.state && delete values['state'];
              !values.city && delete values['city'];
              !values.charging_station && delete values['charging_station'];

              !values.is_ocpi_based_booking && delete values['is_ocpi_based_booking'];
              !values.partyId && delete values['partyId'];
              
              // Convert string to boolean for is_ocpi_based_booking
              const payload = { ...values };
              if (payload.is_ocpi_based_booking === 'true') {
                payload.is_ocpi_based_booking = true;
              } else if (payload.is_ocpi_based_booking === 'false') {
                payload.is_ocpi_based_booking = false;
              }
              
              if (values.charging_station === 'All' && values.state === 'All' && values.city === 'All') {
                const b2cStationChargingHistoryData = {
                  ...payload,
                  state: '',
                  city: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All' && values.charging_station === 'All') {
                const b2cStationChargingHistoryData = {
                  ...payload,
                  state: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.city === 'All' && values.charging_station === 'All') {
                const b2cStationChargingHistoryData = {
                  ...payload,
                  city: '',
                  charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '',
                };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All' && values.city === 'All') {
                const b2cStationChargingHistoryData = { ...payload, state: '', city: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.city === 'All') {
                const b2cStationChargingHistoryData = { ...payload, city: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.state === 'All') {
                const b2cStationChargingHistoryData = { ...payload, state: '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else if (values.charging_station === 'All') {
                const b2cStationChargingHistoryData = { ...payload, charging_station: !_.isEmpty(userProfileStations) ? userProfileStations : '' };
                b2cStationChargingHistory(b2cStationChargingHistoryData);
              } else {
                b2cStationChargingHistory(payload);
              }
              handleAdvanceFilterData(values);
              setSubmitting(false);
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form onSubmit={handleSubmit}>
                <div className="mb-5">
                  <Select
                    label={t('filters.country')}
                    options={_.map(allCountries, (item) => {
                      return { label: item.name, value: item.name };
                    })}
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectCountry')}
                    name="country"
                    value={values.country}
                    onMenuScrollDown={true}
                    getDataOnScrollDown={getAllCountry}
                    page={countryPage}
                    totalPage={countryTotalPage}
                    onChange={(val) => {
                      getStateByCountry({ country_name: val, limit: 999 });
                      setCountry(val);
                      setFieldValue(`country`, val);
                      setFieldValue(`state`, '');
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.state')}
                    options={
                      !changeState
                        ? values.country &&
                        !_.isEmpty(allState) && [
                          { label: 'All', value: 'All' },
                          ..._.map(allState, (state) => {
                            return { label: state.name, value: state.name };
                          }),
                        ]
                        : values.country && !_.isEmpty(allState) && [{ label: 'All', value: 'All' }]
                    }
                    className="filter-select-box"
                    placeholder={t('placeHolder.selectState')}
                    isMulti
                    name="state"
                    value={values.state}
                    onMenuScrollDown={true}
                    // getDataOnScrollDown={(data) => getStateByCountry({ ...data, country_name: values.country })}
                    page={statePage}
                    totalPage={stateTotalPage}
                    onChange={(val) => {
                      if (_.includes(val, 'All')) {
                        getCityByStateName({ state_names: '', limit: 999 });
                        setChangeState(true);
                        setFieldValue(`state`, 'All');
                      } else if (_.isEmpty(val)) {
                        setChangeState(false);
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`state`, '');
                      } else {
                        getCityByStateName({ state_names: val, limit: 999 });
                        setState(val);
                        setCityLimit(true);
                        setChangeState(false);
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`state`, val);
                      }
                      setFieldValue(`city`, '');
                    }}
                  />
                  <Select
                    label={t('filters.city')}
                    options={
                      !changeCity
                        ? !_.isEmpty(values.state) &&
                        !_.isEmpty(allCityByState) && [
                          { label: 'All', value: 'All' },
                          ..._.map(allCityByState, (state) => {
                            return { label: state.name, value: state.name };
                          }),
                        ]
                        : !_.isEmpty(values.state) && values.country && !_.isEmpty(allCityByState) && [{ label: 'All', value: 'All' }]
                    }
                    placeholder={t('placeHolder.selectCity')}
                    name="city"
                    isMulti
                    value={values.city}
                    onMenuScrollDown={true}
                    // getDataOnScrollDown={(data) => getCityByStateName({ ...data, state_names: values.state === 'All' ? '' : values.state })}
                    page={cityByStatePage}
                    totalPage={cityByStateTotalPage}
                    onChange={(val) => {
                      if (_.includes(val, 'All')) {
                        getAllStation({ city_array: '' });
                        setChangeCity(true);
                        setFieldValue(`city`, 'All');
                      } else if (_.isEmpty(val)) {
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue(`city`, '');
                      } else {
                        getAllStation({ city_array: val });
                        setChangeCity(false);
                        setChangeStation(false);
                        setFieldValue('city', val);
                      }
                      setFieldValue(`charging_station`, '');
                    }}
                  />
                  <div className="canvas-selection__block">
                    <Select
                      label={t('filters.station')}
                      options={
                        !changeStation
                          ? (!_.isEmpty(_.get(values, 'city')) && !_.isEmpty(stationList) && _.get(values, 'state') === 'All') ||
                            _.get(stationList, 'city') === _.get(values, 'city')
                            ? [
                              // { label: 'All', value: 'All' },
                              ..._.map(stationList, (station) => {
                                return { label: station?.name, value: station?.id };
                              }),
                            ]
                            : [
                              // { label: 'All', value: 'All' },
                              ..._.map(
                                stationList?.filter((o) => o.state === values.state[0]),
                                (station) => {
                                  return { label: station?.name, value: station?.id };
                                }
                              ),
                            ]
                          : !_.isEmpty(_.get(values, 'city')) &&
                          !_.isEmpty(_.get(values, 'state')) &&
                          values.country &&
                          !_.isEmpty(stationList) && [{ label: 'All', value: 'All' }]
                      }
                      placeholder={t('placeHolder.selectStation')}
                      name="charging_station"
                      isMulti
                      value={values.charging_station}
                      onMenuScrollDown={true}
                      onChange={(val) => {
                        if (_.includes(val, 'All')) {
                          setChangeStation(true);
                          setFieldValue(`charging_station`, 'All');
                        } else if (_.isEmpty(val)) {
                          setFieldValue(`charging_station`, '');
                          setChangeStation(false);
                        } else {
                          setChangeStation(false);
                          setFieldValue(`charging_station`, val);
                        }
                      }}
                    />
                    <Select
                      label={t('filters.tags')}
                      isMulti
                      options={_.map(alltags, (item) => {
                        return { label: item.name, value: item.id };
                      })}
                      className="filter-select-box"
                      placeholder={t('placeHolder.selectTags')}
                      name="tags"
                      value={values.tags}
                      onMenuScrollDown={true}
                      getDataOnScrollDown={getTags}
                      onChange={(val) => {
                        setFieldValue(`tags`, val);
                      }}
                    />
                    <Select
                      label={t('filters.ocpiBooking')}
                      options={[
                        { label: 'true', value: 'true' },
                        { label: 'false', value: 'false' },
                      ]}
                      placeholder={t('placeHolder.selectAnyone')}
                      name="is_ocpi_based_booking"
                      value={values.is_ocpi_based_booking}
                      onChange={(val) => {
                        setFieldValue('is_ocpi_based_booking', val);
                        setIsOcpiPartyId(val);
                      }}
                    />
                    {isOcpiPartyId == 'true' ? (
                      <Select
                        label={t('filters.ocpiParties')}
                        options={[
                          ..._.map(ocpidata, (data) => {
                            return { label: data.partyId, value: data.partyId };
                          }),
                        ]}
                        placeholder={t('filters.selectParty')}
                        name="partyId"
                        onMenuScrollDown={true}
                        getDataOnScrollDown={getOcpidata}
                        page={ocpiPage}
                        totalPage={ocpiTotalPages}
                        value={values.partyId}
                        onChange={(val) => {
                          setFieldValue('partyId', val);
                        }}
                      />
                    ) : null}
                  </div>
                </div>
                <div className="canvas-btn__block">
                  <Button type="submit" className="apply--btn w-100">
                    {t('button.applyFilters')}
                  </Button>
                  <div
                    className="reset--block"
                    onClick={() => {
                      setAdvanceFilterData({});
                      b2cStationChargingHistory();
                      resetForm();
                      onCloseAdvanceFilterPopup();
                    }}
                  >
                    <MdClear size={24} className="reset--icon" />
                    {t('button.clear')}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </OffCanvas>
      )}
    </>
  );
};

export default B2CStationChargingHistory;